<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <!-- Title on the left -->
    <div class="col-lg-8 align-self-center">
      <h2 class="mb-0">RACT Insight</h2>
    </div>
  </div>
  <div class="rbqm-root">

    <div class="p-0 pt-3">
      <!-- Top Summary -->
      <div class="grid mb-2">
        <div class="card span-3 cursor-pointer" @click="openhighriskpopup()">
          <div class="d-flex justify-content-between align-items-center">
          <h3 class="mb-0">Overall Study Risk Score</h3>
          <span
                        class="badge"
                       :class="riskbadgeClass(averageriskscore)"
                        >{{ riskLabel(averageriskscore) }}</span>
        </div>
          <div class="risk-score" :class="riskClass(averageriskscore)">
            {{ overallRiskScore }}
          </div>
          <div>{{ riskLabel(averageriskscore) }}</div>
          <small>KPI Analysed: {{ kpianalysed }}</small>
          <small>Average Risk Score: {{ averageriskscore }}</small>
        </div>

        <div class="card span-9">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h3 class="mb-0">KPI Risk Overview</h3>

            <!-- Risk selector -->
            <select v-model="Category" class="form-select form-select-sm w-25" @change="getriskscoreitembykpi">
              <option v-for="risk in uniqueRiskNames" :key="risk" :value="risk">
                {{ risk }}
              </option>
            </select>
          </div>

          <div class="kpi-tiles">
            <div v-for="kpi in kpis" :key="kpi.name" @click="openkpipopup(kpi.sites, kpi.level)"
              class="kpi-tile cursor-pointer" :class="kpi.level">
              <strong>{{ kpi.name }}</strong><br />
              {{ prettyLevel(kpi.level) }} Risk<br />
              {{ kpi.sitesImpacted }} Sites Impacted
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="card col-lg-6">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">KPI Trend Insights – Latest Reviews</h3>
            <div class="d-flex w-50">
              <select v-model="defaultriskname" class="form-select form-select-sm w-50" @change="kpitrendgraph">
                <option v-for="risk in uniqueRiskNames" :key="risk" :value="risk">
                  {{ risk }}
                </option>
              </select>
              <select v-model="defaultsite" class="form-select form-select-sm w-50 ml-2" @change="kpitrendgraph">
                <option v-for="site in uniqesitecodes" :key="site" :value="site">
                  {{ site }}
                </option>
              </select>
            </div>
          </div>

          <apexchart v-if="kpiTrendSeries.length" type="bar" height="320" :options="kpiTrendOptions"
            :series="kpiTrendSeries" />

          <div v-else class="text-muted p-3">No trend data</div>
        </div>

        <div class="card col-lg-6">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="mb-0">Site vs Study KPI Benchmark</h3>
            <select v-model="sitestudyriskname" class="form-select form-select-sm w-25" @change="sitestudybenchmarkfun">
              <option v-for="risk in uniqueRiskNames" :key="risk" :value="risk">
                {{ risk }}
              </option>
            </select>
          </div>

          <div class="card-body">
            <div v-if="studyBenchmarkLoading" class="text-center py-4">
              Loading…
            </div>

            <apexchart ref="studyBenchmarkChart" type="bar" height="350" :options="studyBenchmarkOptions"
              :series="studyBenchmarkSeries" />
          </div>
        </div>
      </div>
      <!-- Site Prioritization -->
      <div class="wrapper wrapper-content px-0">
        <div class="modal-table-container">
          <div class="section-title">
            <span>Site Performance</span>
          </div>
          <div class="table-responsive" :class="{ 'scrollable-table': performanceList.length > 10 }">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th class="text-center">Rank</th>
                  <th class="text-center">SiteCode</th>
                  <th class="text-center">Average Risk Score</th>
                  <th class="text-center">Total KPIs Analysed</th>
                  <th class="text-center">Run Date</th>
                  <th class="text-center">View</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="list in performanceList" :key="list.id">
                  <td class="text-center">{{ list.rank }}</td>
                  <td class="text-center">{{ list.siteCode }}</td>
                  <td class="text-center d-flex justify-content-center">
                    <div :class="customcolor(list.averageRiskScore)">{{ list.averageRiskScore }}</div>
                  </td>
                  <td class="text-center">{{ list.totalKPIsAnalysed }}</td>
                  <td class="text-center">{{ formatRunDate(list.runDate) }}</td>
                  <td class="text-center">
                    <a @click.prevent="viewDocument(list.kpiWithScores, list.siteId, list.siteCode)">
                      <i class="fa fa-eye edit-delete"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <monitor-kpi-modal v-if="openModal" :kpiwithscores="kpiWithScores" @closeModal="closeModal" @opencreateschdulemodel="opencreateschdule" />
  <riskpopup v-if="showpop == true" :requiredsite="false" popupheadder="Risk Items" :highriskitems="highriskitems"
    @closeModal="closehighriskpopup">

  </riskpopup>
  <riskpopup v-if="kpiriskpopup == true" :requiredsite="true" :popupheadder="popupheadder" :highriskitems="kpiriskarray"
    @closeModal="closehighriskpopup">

  </riskpopup>
  <CreateSchedulePopup v-if="createschedulemodel" :siteId="siteId" :sitecode="siteCodeforpopup" @closescheduleModal="createschedulemodel = false"></CreateSchedulePopup>
</template>

<script src="./RAC_Insiht.js"></script>

<style scoped>
.rbqm-root {
  margin: 0;
  font-family: "Segoe UI", Roboto, Arial, sans-serif;
  background: #f4f6f9;
  color: #1f2937;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.rbqm-header {
  background: #0f172a;
  color: #fff;
  padding: 16px 24px;
  font-size: 20px;
  font-weight: 600;
}

.container {
  padding: 20px;
  flex: 1;
}

.grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 10px;
}

.card {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.card h3 {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}

.risk-score {
  font-size: 48px;
  font-weight: 700;
}

.risk-high {
  color: #dc2626;
  background-color: transparent;
}

.risk-medium {
  color: #f59e0b;
  background-color: transparent;
}

.risk-low {
  color: #16a34a;
  background-color: transparent;
}

.kpi-tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
}

.kpi-tile {
  padding: 12px;
  border-radius: 8px;
  background: #f9fafb;
  border-left: 6px solid;
}

.kpi-tile.high {
  border-color: #dc2626;
}

.kpi-tile.medium {
  border-color: #f59e0b;
}

.kpi-tile.low {
  border-color: #16a34a;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

th,
td {
  padding: 8px;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
}

th {
  background: #f3f4f6;
  font-weight: 600;
}

.rbqm-footer {
  text-align: center;
  padding: 10px;
  font-size: 12px;
  color: #6b7280;
}

.span-3 {
  grid-column: span 3;
}

.span-6 {
  grid-column: span 6;
}

.span-9 {
  grid-column: span 9;
}

.span-12 {
  grid-column: span 12;
}

.mt-16 {
  margin-top: 16px;
}

@media (max-width: 992px) {

  .span-3,
  .span-6,
  .span-9 {
    grid-column: span 12;
  }
}

.highrisk {
  background-color: #F22613;

}

.mediumrisk {
  background-color: #f5d76e;
}

.safe {
  background-color: #87d37c;
}

.inround {
  width: 50px;
  border-radius: 10%;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
